export default __webpack_public_path__ + "static/media/menu-home-icon.b727fa63.svg";